import axios from 'axios'

export function resetEnquiryPrices() {
  return {
    type: 'ENQUIRY_RESET_PRICES',
  }
}

export function fetchEnquiryPrices(listingId, params) {
  return (dispatch) =>
    dispatch({
      type: 'ENQUIRY_FETCH_PRICES',
      payload: axios.get(`/listings/${listingId}/pricing`, { params }),
    })
}
